import { WidgetType } from './WidgetType';

export interface SettingsAccountRouter {
  goBack(prevState: { pathname: string; search: string }): void;

  goToAccountSettings(id: string): void;

  goToRoleModel(id: string): void;

  goToRoleModelExceptions(id: string): void;

  goToAddRoleModelExceptions(id: string): void;

  goToAccountDashboard(id: string): void;

  goToAccountExeptionDashboard(id: string, exceptionId: string): void;

  goToAccountDashboardExceptions(id: string): void;

  goToBusinessTripsExceptions(id: string): void;

  goToAddBusinessTripsExceptions(id: string): void;

  goToAccountWidget(id: string, widgetId: string, widgetType: WidgetType): void;

  goToAccountUsersGroups(id: string): void;

  goToAccountUsersGroupCreation(id: string): void;

  goToAccountUsersGroupAssign(id: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsAccountRouter = Symbol('SettingsAccountRouter');
